export default __webpack_public_path__ + "static/media/app.62b0b75f.PNG";